export const STATSIG_TIER_NAME = import.meta.env.VITE_STATSIG_TIER_NAME;

export const STATSIG_CLIENT_ID = 'client-AxF3D0dNXrBCBjoRSQtJHhgq0ON9N8tDMkSXtJyYqpz';

export const BP_IS_UP = 'bp-is-up';

export const CAN_SEE_BROKER_COMMISSION_FG = 'bp-broker-commission';
